import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20romantic%20cinematic%20scene%20with%20soft%20golden%20sunset%20lighting%2C%20beautiful%20bokeh%20background%2C%20abstract%20warm%20gradient%20with%20rose%20and%20amber%20tones%2C%20dreamy%20atmospheric%20composition%2C%20soft%20focus%2C%20elegant%20minimalist%20aesthetic&width=1920&height=1080&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-200 text-sm font-medium mb-6 backdrop-blur-sm">
            高清完整版 · 无需注册 · 免费观看
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
            暖暖爱视频
            <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-3 text-white/90">
              随时随地，免费畅享高清视频
            </span>
          </h1>
          <p className="text-base md:text-lg text-white/75 mb-8 max-w-xl mx-auto leading-relaxed">
            无需注册、无需下载，提供暖暖爱全集高清完整版在线播放服务。画质清晰流畅，支持手机电脑多端观看。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/aiqing-ju"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观看
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-lg backdrop-blur-sm transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
      {/* Scroll hint */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/60 text-xl"></i>
        </span>
      </div>
    </section>
  );
}